import { SchemaScript } from "@tokenterminal/core/ui/seo/SchemaScript"
import { ORGANIZATION_REF, SITE_URL } from "@tokenterminal/core/ui/seo/SiteSchemas"
import { BreadcrumbSchema } from "@/components/common/Seo/BreadcrumbSchema"
import type { Article } from "@/components/resources/data/posts.types"
import { BASE_BLOG_PATH } from "@/constants/urls"
import { absoluteUrl, authorEntity } from "./AuthorSchema"

const makeSchema = ({
  title,
  image,
  tags,
  author,
  publishedAt,
  modifiedAt,
  category,
  slug,
}: Article) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  headline: title,
  // Undefined keys are left out of the JSON
  image: image ? absoluteUrl(image) : undefined,
  keywords: tags.length ? tags : undefined,
  datePublished: publishedAt,
  dateModified: modifiedAt,
  author: authorEntity(author),
  publisher: ORGANIZATION_REF,
  mainEntityOfPage: `${SITE_URL}${BASE_BLOG_PATH}/${category}/${slug}`,
})

/** BlogPosting and BreadcrumbList JSON-LD for a post page */
export const ArticleSchema = ({ article }: { article: Article }) => {
  const { title, category, categoryName, slug } = article
  const categoryPath = `${BASE_BLOG_PATH}/${category}`
  return (
    <>
      <SchemaScript id="article" schema={makeSchema(article)} />
      <BreadcrumbSchema
        items={[
          { name: "Resources", path: BASE_BLOG_PATH },
          { name: categoryName ?? category, path: categoryPath },
          { name: title, path: `${categoryPath}/${slug}` },
        ]}
      />
    </>
  )
}
